<template>
    <v-list>
      <v-list-item-group
        v-model="selected"
        color="primary"
      >        
        <template v-for="(element,idx) in items" >
            <v-divider :key="idx"></v-divider>
            <v-list-item  :key="element.nome + element.id">    
                <v-col cols="1" v-if="element.img">
                    <expandable-image
                        v-if="element.img"
                        :src="`${element.img}`"
                        :close-on-background-click="true"
                    />        
                </v-col>                 
                <v-col cols="5">
                    <v-list-item-content class="align-center" @click="select(element)" >                                                  
                        <v-list-item-title v-html="element.nome"></v-list-item-title>
                        <v-list-item-subtitle v-if="element.maior == true">Produtos desta categoria devem ser consumidos somente por maiores de 18 anos.</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="element.descricao" v-html="element.descricao"></v-list-item-subtitle>
                    </v-list-item-content>                    
                </v-col>               
                <v-col cols="3">
                    <v-list-item-content class="align-center" @click="select(element)" >                                                  
                        <v-list-item-subtitle v-if="element.preco"> <b>R$:</b> {{element.preco}} </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="element.tamanho"> <b>Tamanhos Disponíveis</b> {{element.tamanho}} </v-list-item-subtitle>
                    </v-list-item-content>                      
                </v-col>
                <v-spacer></v-spacer> 
                <v-list-item-action class="pt-0 pl-0 pb-0 ml-0">
                    <editProd v-if="typeof element.preco != 'undefined'" :selprodId="element.id" :selProd="element" v-on:listEdit="loadData"/>
                    <editCat v-else-if="typeof element.maior != 'undefined'" :selcadId="element.id" :selcad="element" v-on:listEdit="loadData"/>                    
                    <editCol v-else :selColId="element.id" :selCol="element" v-on:listEdit="loadData" v-on:loadMessage="loadMessage"/>
                </v-list-item-action>   
                <v-tooltip top>
                    <template v-slot:activator="{ on }">                     
                        <v-list-item-action v-on="on" class="pt-0 pl-0 pb-0 ml-0">
                            <v-btn icon> 
                                <v-icon v-if="element.ativo == true" @click="disable(element,true)" color="green"> mdi-check-circle </v-icon>                           
                                <v-icon v-if="element.ativo == false" @click="disable(element,false)" color="danger"> mdi-close-circle </v-icon>                       
                            </v-btn>                                               
                        </v-list-item-action>
                    </template>
                    <span v-if="element.ativo == true">Desativar Item.</span>
                    <span v-if="element.ativo == false">Ativar Item.</span>
                </v-tooltip>                  
            </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
</template>
<script>
import editProd from '@/modules/products/products/editProducts'
import editCat from '@/modules/products/category/editCategory'
import editCol from '@/modules/products/collection/editCollection'

export default {
    props:['list'],  
    components: {editProd, editCat, editCol},
    data: () => ({
        items: [],
        selected: []
    }),
    created(){
        this.items = this.list
    },
    methods:{
        loadMessage(value){
            this.$emit("loadMessage", value);            
        },
        loadData(){
            this.$emit("listEdit")
            console.log("teste")
        },
        select(value){
            this.$emit("listSelect",value)
        },
        edit(value){
            this.$emit("listEdit", value)
        },
        disable(element, value){
            let valor = element
            valor.value = value
            this.$emit("listDisable",valor)
        }
    }
}
</script>